module.exports = __webpack_public_path__ + "img/05娄童贤.033d2b0e.jpg";